import api from '.';

export const obterSituacaoAtualDoColaborador = async ({ pessoaId }) => {
    if (!pessoaId) {
        return;
    }
    try {
        const { data } = await api.post('rh/obterSituacaoAtualDoColaborador', { pessoaId });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const obterColaboradorByPessoaId = async ({ pessoaId, consultaDia }) => {
    if (!pessoaId) {
        return;
    }
    try {
        const { data } = await api.post('rh/obterColaboradorByPessoaId', { pessoaId, consultaDia });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const obterCargoByEmpresaId = async ({ empresaId, empresaIds }) => {
    if (!empresaId) {
        return;
    }
    try {
        const { data } = await api.post('rh/obterCargoByEmpresaId', { empresaId, empresaIds });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const obterNivelByEmpresaId = async ({ empresaId }) => {
    if (!empresaId) {
        return;
    }
    try {
        const { data } = await api.post('rh/obterNivelByEmpresaId', { empresaId });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

//rotinas referente ao cargo e suas sub rotinas
export const listarAgentes = async ({ start, size, filters, filtersMode, globalFilter, sorting, cargoId }) => {
    if (!cargoId) {
        return;
    }
    try {
        const { data } = await api.get('rh/listarAgentes', {
            params: { start, size, filters, filtersMode, globalFilter, sorting, cargoId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const listarProcedimentos = async ({ start, size, filters, filtersMode, globalFilter, sorting, cargoId }) => {
    if (!cargoId) {
        return;
    }
    try {
        const { data } = await api.get('rh/listarProcedimentos', {
            params: { start, size, filters, filtersMode, globalFilter, sorting, cargoId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const managerRegistro = async (obj) => {
    try {
        const { data } = await api.post('/rh/cargoCreateOrEditSubRotinas', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const deletarRegistro = async (obj) => {
    try {
        const { data } = await api.post('/rh/cargoDeleteSubRotinas', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const duplicidadeRegistro = async (obj) => {
    try {
        const { data } = await api.post('/rh/cargoDuplicidadeSubRotinas', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const obterTab27eSocial = async (obj) => {
    try {
        const { data } = await api.post('/rh/obterTab27eSocial', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

/* rotina de comprovantes */
export const listarComprovantes = ({ start, size, filters, filtersMode, globalFilter, sorting, registroUUID, tabela }) =>
    api.get('/rh/comprovantes', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            registroUUID,
            tabela,
        },
    });
export const createOrEditComprovante = async (objeto) => {
    try {
        const { data } = await api.post('/rh/comprovantes', objeto, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return data;
    } catch (error) {
        return error;
    }
};
export const deleteComprovante = async ({ uuid, apagarArquivo = false }) => {
    try {
        const { data } = await api.delete('/rh/comprovantes', {
            data: { uuid, apagarArquivo },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

/* rotina de papéis de assinaturas dos carrgos */
export const listarAssinaturaPapeis = async (obj) => {
    try {
        const { data } = await api.post('/cargo/assinatura-papeis', obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
